module.exports = __webpack_public_path__ + "img/fullrategold.549b6454.svg";